import { inject, Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router'
import { PortalService } from '../../../portal/services/portal.service'
import { PortalToken } from '../../rest/types/portal-token'

@Injectable()
export class ValidPortalToken {
  private router = inject(Router)
  private portalService = inject(PortalService)

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean | UrlTree> {
    const token: string | undefined = route.queryParams['t']
    const engineerID: string | undefined = route.queryParams['e']
    const destination: string | undefined = route.queryParams['d']
    if (token && engineerID) {
      this.portalService.setToken({
        token,
        engineerID: parseInt(engineerID),
      } as PortalToken)
    }
    return this.portalService
      .getEngineer()
      .then((engineer) => {
        if (engineer != null) {
          if (destination) {
            let parts: string[]
            let queryParams: Record<string, string> | undefined = undefined
            switch (destination) {
              case 'dashboard':
                parts = []
                break
              case 'notices':
                parts = ['notices']
                break
              case 'files':
                parts = ['files']
                break
              default:
                parts = ['files']
                queryParams = { query: destination }
                break
            }
            return this.router.createUrlTree(['/portal', ...parts], {
              queryParams,
            })
          }
          return true
        }
        return this.router.createUrlTree(['/portal', 'no-access'])
      })
      .catch(() =>
        Promise.resolve(this.router.createUrlTree(['/portal', 'no-access']))
      )
  }
}
